import gql from 'graphql-tag'

const GET_TENANTS = gql`
  {
    tenants {
      total
      data {
        id
        name
        logoUrl
        logoUrlCf
        client {
          id
          name
          defaultProjectImage
          defaultProjectImageCf
          slug
          uploadPortalImage
          uploadPortalImageCf
          uploadPortalLoginImage
          uploadPortalLoginImageCf
          uploadPortalTitle
          uploadPortalDescription
          uploadPortalSlug
        }
      }
    }
  }
`

export { GET_TENANTS }